export default function getStartPath(attributes) {
    if (attributes.path) {
        return attributes.path;
    }
    return '/';
}
